
import React, { useMemo } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const LawmakerContainer = styled.div`
  display: flex;
  width: ${props => props.$isMobile ? '100%' : 'auto'};

  @media (max-width: 768px) {
    display: ${props => props.$isMobile ? 'flex' : 'none'};
  }
`;

const LawmakerWrapper = styled.div`
  width: ${(props) =>
    props.$isMobile || props.$fullWidth ? '100%' : '9.375rem'};
`;

export default function LawmakerSelector({ 
  lawmakers, 
  handleLawmakerSelect, 
  isMobile = false,
  chamberFilter = 'both',
  setChamberFilter,
  showChamber = true,
}) {
  const lawmakerSelectOptions = useMemo(() => {
    return lawmakers.map((lawmaker) => ({
      value: lawmaker.pid,
      label: `${lawmaker.first} ${lawmaker.last} (${lawmaker.party[0]})`,
    }));
  }, [lawmakers]);
  
  const selectStyles = {
    control: (base) => ({
      ...base,
      border: '1px solid #cccccc',
      borderRadius: '0.25rem',
      boxShadow: 'none',
      minHeight: '2rem',
      fontSize: '0.875rem',
      '&:hover': {
        border: '1px solid #cccccc',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#212121',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#212121',
      padding: '0 0.5rem 0 0',
      '&:hover': {
        color: '#000000',
      },
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  return (
    <LawmakerContainer $isMobile={isMobile}>
      <LawmakerWrapper $isMobile={isMobile} $fullWidth={!showChamber}>
        <Select
          value={null}
          options={lawmakerSelectOptions}
          placeholder="Select legislators"
          onChange={handleLawmakerSelect}
          isClearable={true}
          styles={selectStyles}
        />
      </LawmakerWrapper>
    </LawmakerContainer>
  );
}
